export const listingRegex =
  /zillow.com\/home(detail)?s\/[^/]*?\/(?<id>\d+)_(zpid)/
